import { useState, useEffect } from 'react';
import Dialog from '../../../common/dialog';
import l from '../../../../lang';
import './styles.scss';
import DialogInviteStep1 from './step1';
import DialogInviteStep2 from './step2';
import { InvitationProvider } from './invitation-context';
import { DialogInviteStep3 } from './step3';
import { useUserManagement } from '../../../../store/user-management';

interface DialogInviteProps {
  open: boolean;
  onClose: () => void;
  onSuccessInvite?: () => void;
}

const DialogInvite = ({ open, onClose, onSuccessInvite }: DialogInviteProps) => {
  const [step, setStep] = useState(0);
  const [invitationKey, setInvitationKey] = useState(0);
  const { cleanError } = useUserManagement();

  const steps = [
    {
      component: <DialogInviteStep1 onNext={() => setStep(1)} />,
      type: 'sm',
      title: l('userManagement.inviteTitle'),
    },
    {
      component: <DialogInviteStep2 onNext={() => setStep(2)} onBack={() => setStep(0)} />,
      type: 'lg',
      title: l('userManagement.inviteTitle'),
    },
    {
      component: <DialogInviteStep3 />, 
      type: 'sm',
      title: '',
    },
  ];

  const handleClose = () => {
    setStep(0);
    setInvitationKey(prev => prev + 1);
    cleanError();
    if (step === 2 && typeof onSuccessInvite === 'function') {
      onSuccessInvite();
    }
    onClose();
  };

  useEffect(() => {
    if (open) cleanError();
  }, [open]);

  return (
    <InvitationProvider key={invitationKey}>
      <Dialog
        open={open}
        dividers={false}
        title={steps[step].title}
        type={steps[step].type}
        handleClose={handleClose}
        body={steps[step].component}
      />
    </InvitationProvider>
  );
};

export default DialogInvite;
